/* global LOCALE, MOMENT_LOCALE */

window.userLocaleData = require('@dynamic/user-locale-data');

window.LOCALE = LOCALE;
window.MOMENT_LOCALE = MOMENT_LOCALE;
